export const UI_TRANSLATIONS_NAMESPACE = '@project44/login-ui';
